import type { Predicate } from './types';

export const not =
    <T>(predicate: Predicate<T>): Predicate<T> =>
    (candidate) =>
        !predicate(candidate);
